import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, formatCurrency } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    useEffect(()=>{
        if(window.outerWidth <= 768){
            // jQuery(".quick-search-results").insertAfter(jQuery("form.search__form"));
            document.querySelector("form.search__form")?.after(document.querySelector(".quick-search-results"));

        }

        document.querySelector(".search__suggestions-wrapper")?.remove();

    })

    return (
        <div class="quick-search-results">
            <div class="quick-search-results__wrapper">
                <div class="quick-search-results__section quick-search-results__section--Suggestions">
                    <div class="quick-search-results__grid quick-search-results__grid--Suggestions">
                    <Keywords
                            hits={keywords.hits}
                            keywordComponent={Keyword}
                            elementComponent={Element}
                            keywordInCategoryComponent={KeywordInCategory}
                        />
                    </div>
                </div>
                {products?.hits?.length > 0 && (
                <div class="quick-search-results__section quick-search-results__section--Products nosto-results">
                    <div class="quick-search-results__grid quick-search-results__grid--Products">
                    {products?.hits?.map(hit => {
                        return (
                        <div class="quick-search-results__cell">
                        <a href={hit.url} class="quick-search-results__image-wrapper aspect-ratio aspect-ratio--portrait"><img src={`${hit.imageUrl}&width=400`} alt={hit.name} class="quick-search-results__image" /></a>
                        <h4 class="quick-search-results__vendor">{hit.name}</h4>
                        <h4 class="quick-search-results__title">
                            <a href={hit.url}>{hit.name}</a>
                        </h4>
                        <p class="quick-search-results__price"><span class="money">${hit.price}</span></p>
                        </div>
                        )
                    })}
                    </div>
                </div>
                )}
            </div>
            <a href="/search?type=product&amp;q=shirt" class="quick-search-results__view-all" onClick={(e)=>{
                e.preventDefault();
                document.querySelector('.search__input').form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
            }}><span>View more results</span></a>
            </div>
        // <div
        //     class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
        //     data-nosto-element="autocomplete"
        // >
        //     <div class="ns-w-100 ns-mt-sm-auto">
        //         <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
        //             {keywords?.hits?.length > 0 && (
        //                 <div
        //                     class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
        //                         products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
        //                     }`}
        //                 >
        //                     {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
        //                         Keywords
        //                     </div> */}
        //                     <div class="ns-d-flex ns-flex-column">
                                // <Keywords
                                //     hits={keywords.hits}
                                //     keywordComponent={Keyword}
                                //     elementComponent={Element}
                                //     keywordInCategoryComponent={KeywordInCategory}
                                // />
        //                     </div>
        //                     {!products?.hits?.length && <SubmitButton text="See all search results" />}
        //                 </div>
        //             )}
        //             {products?.hits?.length > 0 && (
        //                 <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
        //                     {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
        //                         Products
        //                     </div> */}
        //                     <div class="ns-d-flex ns-flex-column">
        //                         {products?.hits?.map(hit => {
        //                             return (
        //                                 <AutocompleteElement hit={hit}>
        //                                     <div
        //                                         data-url={hit.url}
        //                                         class="ns-d-flex flex-row ns-clickable ns-p-2"
        //                                         data-nosto-element="product"
        //                                     >
        //                                         <img
        //                                             class="ns-h-auto ns-object-contain"
        //                                             src={hit.imageUrl ?? productImagePlaceholder}
        //                                             alt={hit.name}
        //                                             width="60"
        //                                             height="40"
        //                                         />
        //                                         <div class="ns-pl-2">
        //                                             {hit.brand && (
        //                                                 <div class="ns-color-black ns-mb-1 ns-font-4">{hit.brand}</div>
        //                                             )}
        //                                             <div class="ns-mb-2 ns-font-4 ns-clipped ns-text-one-line">
        //                                                 {hit.name}
        //                                             </div>
        //                                             <div>
        //                                                 <span>{format(hit.price)}</span>
        //                                                 {hit.listPrice && hit.listPrice > hit.price && (
        //                                                     <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
        //                                                         {format(hit.listPrice)}
        //                                                     </span>
        //                                                 )}
        //                                             </div>
        //                                         </div>
        //                                     </div>
        //                                 </AutocompleteElement>
        //                             )
        //                         })}
        //                     </div>
        //                     <SubmitButton text="See all search results" />
        //                 </div>
        //             )}
        //         </div>
        //     </div>
        // </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
